import * as React from 'react'

const SvgIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='223'
    height='91'
    fill='none'
    viewBox='0 0 223 91'
    {...props}
  >
    <mask
      id='mask0_3924_8564'
      width='223'
      height='91'
      x='0'
      y='0'
      maskUnits='userSpaceOnUse'
      style={{ maskType: 'luminance' }}
    >
      <path fill='#fff' d='M223 0H0v90.33h223z'></path>
    </mask>
    <g fill='#4E4FF6' mask='url(#mask0_3924_8564)'>
      <path d='M73.72 10.137a10.35 10.35 0 0 1-1.782 5.754 10.4 10.4 0 0 1-4.69 3.802 10.47 10.47 0 0 1-6.021.57A10.44 10.44 0 0 1 55.9 17.41a10.37 10.37 0 0 1-2.84-5.317 10.34 10.34 0 0 1 .602-5.992 10.4 10.4 0 0 1 3.841-4.651 10.46 10.46 0 0 1 5.788-1.746A10.41 10.41 0 0 1 70.7 2.747c.97.97 1.737 2.124 2.256 3.393a10.3 10.3 0 0 1 .765 3.997'></path>
      <path d='M74.11 10.137c0 2.064-.614 4.083-1.765 5.8a10.47 10.47 0 0 1-4.704 3.846c-1.915.79-4.023.998-6.057.596a10.5 10.5 0 0 1-5.369-2.856 10.42 10.42 0 0 1-2.87-5.344 10.4 10.4 0 0 1 .596-6.031 10.45 10.45 0 0 1 3.861-4.685 10.52 10.52 0 0 1 9.836-.966 10.5 10.5 0 0 1 3.4 2.261 10.395 10.395 0 0 1 3.071 7.379M45.402 25.24v15.466h-18.04v25.658c0 5.701 2.62 7.946 8.532 7.946h9.57v14.8H34.675c-17.004 0-24.683-7.582-24.683-21.897V40.706H.667V25.239a9.3 9.3 0 0 0 6.55-2.698A9.183 9.183 0 0 0 9.93 16.02V8.8H27.3v16.44zM72.277 25.24h-17.37v63.872h17.37zM131.337 84.44c-4.51 3.519-11.519 5.581-18.771 5.581a32.6 32.6 0 0 1-12.451-2.497 32.5 32.5 0 0 1-10.537-7.06 32.3 32.3 0 0 1-7.015-10.54 32.2 32.2 0 0 1-2.421-12.414c0-18.44 14.872-32.876 32.424-32.876 7.252 0 14.261 2.244 18.771 5.702V3.829h17.37v85.343h-17.37zm.245-26.93a17.2 17.2 0 0 0-1.358-6.615 17.3 17.3 0 0 0-3.804-5.589 17.3 17.3 0 0 0-5.668-3.706 17.4 17.4 0 0 0-6.662-1.256c-9.508 0-16.882 7.703-16.882 17.165 0 9.584 7.374 17.166 16.882 17.166 9.995 0 17.492-7.582 17.492-17.165M188.322 90.628c-20.54 0-33.765-14.315-33.765-33.24 0-18.437 13.774-33.36 33.886-33.36 20.296 0 32.546 13.95 32.546 32.511 0 2.487-.245 5.702-.245 6.126h-49.061c1.89 8.068 7.984 13.347 17.004 13.347 7.741 0 13.409-3.336 17.005-8.492l13.042 7.947c-6.216 9.338-16.15 15.161-30.412 15.161m-16.03-40.82h31.146c-1.891-7.705-8.107-11.588-15.116-11.588-8.106 0-13.774 4.368-16.03 11.586z'></path>
    </g>
  </svg>
)

export default React.memo(SvgIcon)
